import { render, staticRenderFns } from "./UserCard.vue?vue&type=template&id=5e9f6bed&scoped=true"
import script from "./UserCard.vue?vue&type=script&lang=ts"
export * from "./UserCard.vue?vue&type=script&lang=ts"
import style0 from "./UserCard.vue?vue&type=style&index=0&id=5e9f6bed&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e9f6bed",
  null
  
)

export default component.exports